<template>
  <div>
    <PageMain
      ref="main"
      :loading="loading"
      :tableData="tableData"
      :disabled="disabled"
      @reload="getData()"
      @openEditDialog="openEditDialog"
    >
      <template #header>
        <div class="d-flex align-items-stretch">
          <div class="side-frame"></div>
          <div class="d-flex align-items-center">
            <span style="font-size: 14px; color: #606266">
              {{ $l('table_header_title_sample') || '样品需求明细' }}
            </span>
          </div>
        </div>
      </template>
    </PageMain>

    <SampleSet
      :visible.sync="editOpts.visible"
      :disabled="editOpts.disabled"
      :amzPurchaseDetailCode="editOpts.amzPurchaseDetailCode"
      @reload="setReload()"
    />
  </div>
</template>
<script>
import PageMain from './main'
import SampleSet from '../sample-set'
import EditLoading from '@/mixins/edit-loading'
export default {
  components: { PageMain, SampleSet },
  mixins: [EditLoading],
  props: {
    disabled: { type: Boolean, default: false },
    amzPurchaseCode: { type: String, default: '' },
  },
  data() {
    return {
      tableData: [],
      loading: false,
      editOpts: {
        visible: false,
        disabled: false,
        amzPurchaseDetailCode: '',
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.amzPurchaseCode) return

      this.loading = true
      const res = await this.$api
        .ecomAmzFtyPurchaseSampleListingApi({
          amzPurchaseCode: this.amzPurchaseCode,
        })
        .catch(() => null)
      this.loading = false

      this.tableData = res?.body?.data || []
    },
    openEditDialog({ row, type } = {}) {
      this.editOpts = {
        visible: true,
        disabled: type == 'detail',
        amzPurchaseDetailCode: row.amzPurchaseDetailCode,
      }
    },
    setReload() {
      this.getData()
      this.$emit('reload')
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 5px;
  border-left: 3px solid $color-primary;
  margin-top: 3px;
  margin-bottom: 3px;
}
</style>
